import { Injectable } from '@angular/core';
import { Observable, Observer, Subject, BehaviorSubject } from 'rxjs';
import { AnonymousSubject } from 'rxjs/internal/Subject';
import { map } from 'rxjs/operators';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment } from 'src/environments/environment';
import { MessageType } from '../enums/message-type';
import { Booking } from '../interfaces/booking';
import { OwnEvent } from '../interfaces/own-event';

export interface BookingMessage {
  type: MessageType;
  booking: Booking;
}

export interface EventMessage {
  type: MessageType;
  event: OwnEvent;
}

@Injectable({
  providedIn: 'root',
})



export class WebSocketService {
  //public messages: Subject<BookingMessage>;
  //private subject: AnonymousSubject<MessageEvent>;
  public websocketConnectedEvent: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public websocketConnectedBooking: BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor() { }

  public webSocketTry(companyId: string): WebSocketSubject<any> {
    const url = new URL(
      `${environment.ws_url}/bucket/${environment.buckets.events}/data`
    );
    url.searchParams.set('filter', JSON.stringify({ company: companyId }));
    url.searchParams.set('Authorization', `APIKEY ${environment.apikey}`);
    const subject = webSocket(url.toString())
    return subject


  }


  public createWebSocketBooking(companyId: string) {
    const url = new URL(
      `${environment.ws_url}/bucket/${environment.buckets.bookings}/data`
    );
    url.searchParams.set('filter', JSON.stringify({ company: companyId }));
    url.searchParams.set('Authorization', `APIKEY ${environment.apikey}`);

    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    let messages = <Subject<any>>this.connect(url, "booking").pipe(
      map((response: MessageEvent): BookingMessage => {
        const data = JSON.parse(response.data);

        const dataConvert = new Object() as BookingMessage;
        dataConvert.booking = data.document;
        dataConvert.type = data.kind as MessageType;

        return dataConvert;
      })
    );
    return messages;
  }

  public createWebSocketEvent(companyId: string) {
    const url = new URL(
      `${environment.ws_url}/bucket/${environment.buckets.events}/data`
    );
    url.searchParams.set('filter', JSON.stringify({ company: companyId }));
    url.searchParams.set('Authorization', `APIKEY ${environment.apikey}`);




    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    let messages = <Subject<any>>this.connect(url, "event").pipe(
      map((response: MessageEvent): EventMessage => {
        const data = JSON.parse(response.data);

        const dataConvert = new Object() as EventMessage;
        dataConvert.event = data.document;
        dataConvert.type = data.kind as MessageType;

        return dataConvert;
      })
    );
    return messages;
  }

  public connect(url: URL, type): AnonymousSubject<MessageEvent> {
    //if (!this.subject) {
    let subject = this.create(url, type);
    console.log('Successfully connected: ' + url);
    //}
    return subject;
  }
  private create(url: URL, type): AnonymousSubject<MessageEvent> {
    const ws = new WebSocket(url);

    const observable = new Observable((obs: Observer<MessageEvent>) => {
      ws.onmessage = obs.next.bind(obs);
      ws.onerror = obs.error.bind(obs);
      ws.onclose = obs.complete.bind(obs);
      return ws.close.bind(ws);
    });
    const observer = {
      error: null,
      complete: null,
      // eslint-disable-next-line @typescript-eslint/ban-types
      next: (data: Object) => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify(data));
          if (type === "event") {
            this.websocketConnectedEvent.next(true)
          }
          else {
            this.websocketConnectedBooking.next(true)
          }

        }
        else {
          if (type === "event") {
            this.websocketConnectedEvent.next(false)
          }
          else {
            this.websocketConnectedBooking.next(false)
          }

        }
      },
    };
    return new AnonymousSubject<MessageEvent>(observer, observable);
  }
}

